import React from 'react'
import { PoliticasWrapper } from 'styles/global'
import Simple from 'layouts/simple'

const AvisoPrivacidade = () => {
  return (
    <>
      <Simple>
        <PoliticasWrapper>
          <div className="container">
            <h1 className="titulo">Aviso de Privacidade dos Clientes</h1>

            <div className="d-flex flex-column gap-4">
              <section>
                <p>
                  Este aviso de privacidade fornece informações sobre como,
                  quando e por que coletamos e processamos os seus dados
                  pessoais.
                </p>
                <p>
                  Consulte sempre esse aviso para obter informações sobre como
                  iremos coletar e processar seus dados pessoais para o
                  fornecimento de nossos serviços.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Os Princípios de Privacidade da empresa
                </h2>
                <p>
                  Temos a responsabilidade, de acordo com a Lei Geral de
                  Proteção de Dados Pessoais, de fornecer aos Titulares do Dados
                  informações sobre como realizamos o tratamento dos seus dados
                  pessoais. Fazemos isso de várias maneiras. Uma delas é através
                  da publicação de avisos ou políticas de privacidade.
                </p>
                <p>
                  Estamos empenhados em salvaguardar a privacidade e a segurança
                  dos seus dados pessoais.
                </p>
                <p>
                  É importante que você leia este Aviso de Privacidade e esteja
                  ciente de como e para quais finalidades a empresa usará seus
                  dados pessoais e quais os seus direitos no que diz respeito à
                  proteção de Dados Pessoais.
                </p>
                <p>
                  Para garantir que tratamos os seus dados pessoais de forma
                  justa e legal, iremos informar:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-foreground mb-4">
                  <li>Porque coletamos seus dados;</li>
                  <li>Como eles serão usados; e</li>
                  <li>Com quem eles serão compartilhados.</li>
                </ul>
                <p>
                  Também explicaremos quais direitos você tem para controlar
                  como usamos suas informações e como nos informar sobre suas
                  necessidades de informação. Nós disponibilizaremos este Aviso
                  de Privacidade em nosso website.
                </p>
                <p>
                  Por &quot;seus dados pessoais&quot;, entendemos qualquer
                  informação sobre você, que você ou terceiros nos forneçam e
                  que iremos tratar de acordo com os seguintes Princípios de
                  Privacidade:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>
                    Nós apenas coletaremos e usaremos seus dados pessoais quando
                    tivermos motivos legais e razões comerciais legítimas para
                    fazê-lo;
                  </li>
                  <li>
                    Seremos transparentes em nossas negociações com você e
                    informaremos como coletaremos e usaremos seus dados
                    pessoais;
                  </li>
                  <li>
                    Se coletamos seus dados pessoais para uma finalidade
                    específica, não os usaremos para mais nada, a menos que você
                    tenha sido informado e, quando relevante, tenha nos
                    fornecido o seu consentimento;
                  </li>
                  <li>
                    Não solicitamos mais dados pessoais além daqueles
                    necessários para os fins para os quais os estamos coletando;
                  </li>
                  <li>
                    Atualizaremos nossos registros sobre você quando você nos
                    informar que seus dados foram alterados;
                  </li>
                  <li>
                    Continuaremos a revisar e avaliar a qualidade dos dados
                    pessoais que mantemos a seu respeito;
                  </li>
                  <li>
                    Implementamos e cumprimos as políticas de retenção de
                    informações relacionadas aos seus dados pessoais e
                    garantiremos que seus dados pessoais sejam descartados com
                    segurança ao final do período de retenção apropriado;
                  </li>
                  <li>
                    Observaremos sempre os direitos concedidos a você pelas leis
                    aplicáveis de privacidade e proteção de dados e garantiremos
                    que as dúvidas relacionadas a questões de privacidade sejam
                    tratadas de forma rápida e transparente;
                  </li>
                  <li>
                    Treinamos nossa equipe para que saibam quais são suas
                    obrigações em relação a privacidade e proteção dos dados
                    pessoais que coletam, acessam, processam, armazenam e
                    compartilham com terceiros;
                  </li>
                  <li>
                    Adotamos medidas técnicas e administrativas aptas a proteger
                    os seus dados pessoais de acessos não autorizados e de
                    situações acidentais ou ilícitas de destruição, perda,
                    alteração, comunicação ou difusão, independentemente de onde
                    eles sejam armazenados;
                  </li>
                  <li>
                    Procuramos garantir sempre que, ao terceirizarmos qualquer
                    processo, o fornecedor tenha as medidas de segurança
                    adequadas em vigor e exigiremos contratualmente que cumpram
                    nossos Princípios de Privacidade e Proteção de Dados;
                  </li>
                  <li>
                    Asseguraremos a existência de salvaguardas adequadas caso
                    tenhamos que transferir seus dados pessoais para outros
                    países.
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="subtitulo"> Controlador dos dados pessoais</h2>
                <p>
                  O controlador dos dados pessoais é a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , pessoa jurídica de direito privado inscrita no CNPJ&nbsp;
                  <strong>04.380.132/0001-47</strong>, tem sua matriz instalada
                  na Av. Antônio Diederichsen, nº 400, sala 16, Jardim América,
                  na cidade de Ribeirão Preto/SP, CEP: 14.020-250.
                </p>
                <p>
                  Isso significa que ela é responsável por decidir como protege
                  e utiliza os dados pessoais relacionados aos serviços que
                  fornece.
                </p>
                <p>
                  Para obter mais informações sobre como a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;usa seus dados pessoais, entre em contato conosco
                  através do e-mail:&nbsp;
                  <a
                    href="mailto:dpo@ribercred.com.br"
                    className="hover:underline"
                  >
                    dpo@ribercred.com.br
                  </a>
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Coleta e utilização de dados pessoais
                </h2>
                <p>
                  Coletamos e processaremos dados pessoais de indivíduos que
                  usam nossos serviços, bem como de pessoas associadas a nossos
                  clientes e que estejam devidamente autorizados a agir em nome
                  do nosso cliente. Os dados pessoais serão coletados
                  diretamente do indivíduo, de
                  instituições-financeiras-clientes, de
                  instituições-financeiras-parceiras, de fontes disponíveis
                  publicamente ou de terceiros que nos prestam serviços.
                </p>
                <p>
                  Os dados pessoais são usados para gerenciar o relacionamento
                  que temos com nossos clientes e para cumprir os requisitos
                  regulamentares ou legais impostos a nós em cada jurisdição.
                </p>
                <p>
                  Os dados pessoais também serão usados para convidar os
                  clientes para eventos, informá-los sobre outros serviços e
                  oportunidades que acreditamos ser do interesse do cliente e
                  para enviar comunicações que forneçam análises e percepções
                  econômicas e do setor. Os clientes podem cancelar a qualquer
                  momento o recebimento de tais comunicações. Para comunicações
                  realizadas através e-mail, uma oportunidade de cancelar a
                  comunicação será fornecida no próprio e-mail.
                </p>
                <p>
                  Se você se registrar para usar nossos serviços solicitaremos
                  que você forneça alguns dados pessoais para fins de segurança,
                  identificação e verificação.
                </p>
                <p>
                  Se lhe for pedido que forneça dados pessoais sobre terceiros,
                  você deverá garantir e comprovar que tem o consentimento deles
                  ou tem o direito de fornecer as informações a respeito deles
                  à&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                </p>
                <p>
                  Também coletaremos dados pessoais de pessoas que visitam e
                  usam nossos sites. Isso inclui:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-foreground mb-4">
                  <li>
                    Informações fornecidas para se registrar e usar nossos
                    serviços online;
                  </li>
                  <li>Informações fornecidas nos formulários de contato;</li>
                  <li>
                    O uso de cookies e tecnologias semelhantes. Para obter mais
                    informações, consulte nossa Política de Privacidade do
                    website
                  </li>
                </ul>
                <p>
                  As categorias de dados pessoais que coletamos e processaremos
                  para fornecer nossos serviços se restringem ao mínimo
                  necessário para a realização dos propósitos indicados,
                  conforme constar nos formulários e documentos que forem
                  preenchidos, e incluirá:
                </p>

                <div className="overflow-x-auto mb-4">
                  <table className="w-full border-collapse border border-border">
                    <thead>
                      <tr className="bg-muted">
                        <th className="border border-border p-3 text-left text-foreground">
                          Dados Pessoais
                        </th>
                        <th className="border border-border p-3 text-left text-foreground">
                          Finalidade
                        </th>
                        <th className="border border-border p-3 text-left text-foreground">
                          Titular do Dado
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-border p-3 text-foreground align-top">
                          <strong>Dados de identificação</strong>
                          <br />
                          (nome, sobrenome; CPF; RG, CNH, CTPS; idade, data de
                          nascimento; gênero; filiação; escolaridade)
                          <br />
                          <br />
                          <strong>Dados de contato</strong>
                          <br />
                          (endereço completo, CEP; telefone; e-mail)
                          <br />
                          <br />
                          <strong>Dados financeiros</strong>
                          <br />
                          (dados bancários, rendimentos, dívidas, histórico
                          financeiro, informações de agências de referência de
                          crédito e agências de prevenção de fraude)
                          <br />
                          <br />
                          <strong>Dados sobre a vida familiar</strong>
                          <br />
                          (estado civil; nome cônjuge)
                          <br />
                          <br />
                          <strong>Dados sobre a vida profissional</strong>
                          <br />
                          (CV, situação profissional, experiência profissional,
                          escolaridade, formação, diplomas)
                        </td>
                        <td className="border border-border p-3 text-foreground align-top">
                          • Gerenciamento das relações financeiras com nossos
                          clientes
                          <br />
                          • Administração dos serviços contratados pelos nossos
                          clientes
                          <br />
                          • Processamento de transações financeiras
                          <br />
                          • Processamento de instruções de clientes
                          <br />
                          • Gestão legal e de disputas
                          <br />
                          • Conformidade com as obrigações legais e regulatórias
                          <br />• Pesquisas e análises estatísticas com o
                          objetivo de melhorar nossos serviços
                        </td>
                        <td className="border border-border p-3 text-foreground align-top">
                          CLIENTES
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p>
                  Quando formos obrigados ou permitidos pela legislação e
                  regulamentação monitoraremos ou registraremos suas
                  comunicações conosco, incluindo chamadas telefônicas e
                  mensagens de e-mails. Usaremos esse monitoramento e registro
                  para verificar as instruções fornecidas para nós, para fins de
                  evidências, para avaliar e melhorar nossos serviços e para
                  fins de treinamento e qualidade.
                </p>
                <p>
                  Usamos câmeras de vigilância dentro e ao redor de nossas
                  instalações para a prevenção e detecção de crimes, as quais
                  monitoram e coletam imagens, e gravações de voz de acordo com
                  os requisitos legais.
                </p>
                <p>
                  Retemos dados pessoais durante todo o relacionamento com o
                  cliente e, depois de seu término, pelo tempo necessário para a
                  defesa de nossos direitos, para o cumprimento das obrigações
                  legais e regulatórias a que estamos sujeitos e quando tivermos
                  um motivo comercial legítimo para fazê-lo.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">Bases legais</h2>
                <p>
                  Trataremos os seus dados pessoais para os propósitos
                  envolvidos no fornecimento de nossos serviços ou para a
                  execução de um contrato que você tenha conosco. O tratamento
                  também será realizado para fins de interesses legítimos
                  da&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , ou de terceiros, para a defesa de nossos direitos e para o
                  cumprimento das obrigações legais e regulatórias a que estamos
                  sujeitos.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Guarda, retenção e proteção de seus dados pessoais
                </h2>
                <p>
                  Os dados serão armazenados em uma variedade de locais
                  diferentes, incluindo softwares e sistemas de TI
                  proprietários, serviços em nuvem, e-mail e sistemas de
                  gerenciamento de documentos. Os dados serão compartilhados e
                  acessíveis apenas pela equipe envolvida com os serviços que
                  fornecemos.
                </p>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;armazena seus dados pessoais apenas pelo tempo
                  necessário para as finalidades para as quais foram
                  originalmente obtidos, inclusive para atender a requisitos
                  legais e regulatórios, cumprimento de contratos, interesses
                  legítimos e exercício de direitos da&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , e de terceiros.
                </p>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , possui um programa de governança em privacidade de dados
                  pessoais baseado em políticas e regras relativas à proteção de
                  dados sob a vigilância constante de seu Encarregado pelo
                  Tratamento e Proteção de Dados Pessoais.
                </p>
                <p>
                  Além disso, a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , adota medidas técnicas e administrativas de segurança e
                  classificação de informações para garantir a
                  confidencialidade, integridade e disponibilidade dos dados
                  pessoais que ela controla, de acordo com a tecnologia
                  existente e as melhores práticas do setor.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Compartilhamento de seus dados pessoais
                </h2>
                <p>
                  Operamos nacionalmente e muitas vezes precisaremos
                  compartilhar informações com outras empresas do Grupo, outras
                  unidades da empresa, entidades, agentes, parceiros e
                  fornecedores externos para conduzir nossos negócios, apoiar
                  nossos clientes e quando terceirizamos funções operacionais.
                </p>
                <p>
                  Quando um serviço é fornecido aos nossos clientes, os dados
                  pessoais podem ser acessados internamente por diferentes
                  departamentos da empresa para os fins descritos neste aviso de
                  privacidade ou quando for necessário para a realização de uma
                  transação com o cliente ou para conformidade com requisitos
                  regulamentares ou legais que nos são impostos.
                </p>
                <p>
                  Compartilharemos dados pessoais com autoridades externas
                  quando formos solicitados ou autorizados a fazê-lo por lei,
                  regulamento, ordem judicial ou autoridade de supervisão e
                  regulamentação.
                </p>
                <p>
                  Poderemos fornecer dados pessoais aos nossos fornecedores,
                  agentes, instituições financeiras clientes e instituições
                  financeiras parceiras para que processem dados pessoais em
                  nosso nome. Quando isto for necessário faremos as devidas
                  diligências, atividades de monitoramento e garantia para
                  certificar que os dados pessoais sejam devidamente protegidos.
                  Nestes casos cláusulas contratuais serão acordadas entre as
                  partes para garantir a privacidade, confidencialidade e
                  proteção dos dados pessoais compartilhados.
                </p>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;também compartilhará seus dados com empresas, órgãos,
                  organizações, associações e entidades públicas e privadas, se
                  for necessário para atender a quaisquer requisitos legais e
                  regulatórios, requisitos do contrato, interesses legítimos
                  da&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;e para a defesa de nossos direitos. Algumas destas
                  empresas, órgãos, organizações, associações e entidades, podem
                  estar localizados no exterior e, nesse caso, a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , adotará medidas e salvaguardas adicionais para a garantia de
                  um nível adequado de proteção de dados, de acordo com a
                  legislação brasileira.
                </p>
                <p>
                  Dados pessoais serão fornecidos a terceiros como resultado de
                  qualquer reestruturação, venda ou aquisição de qualquer
                  empresa dentro do Grupo.
                </p>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , possui políticas e normas corporativas a respeito da
                  segurança no compartilhamento de dados com terceiros para
                  cumprimento da legislação e proteção da privacidade de nossos
                  clientes.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">Visitas ao nosso website</h2>
                <p>
                  Quando um cliente visita nosso website, usamos serviços de
                  terceiros, como o Google Analytics, para coletar informações
                  de registro padrão da Internet e detalhes dos padrões de
                  comportamento do visitante. Fazemos isso para descobrir coisas
                  como o número de visitantes nas várias partes do website.
                  Essas informações são processadas de forma a não permitir que
                  o visitante de nosso website possa ser identificado. Não
                  fazemos e não permitimos que o Google realize qualquer
                  tentativa de descobrir a identidade das pessoas que visitam
                  nossos websites. Se quisermos coletar informações de
                  identificação pessoal por meio de nossos websites, seremos
                  transparentes sobre isso. Deixaremos claro quando coletarmos
                  informações pessoais e explicaremos o que pretendemos fazer
                  com elas.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">Uso de cookies</h2>
                <p>
                  Um cookie é um arquivo de texto simples que é armazenado em
                  seu computador ou dispositivo móvel pelo servidor de um
                  website e apenas esse servidor é capaz de recuperar ou ler o
                  conteúdo desse cookie.
                </p>
                <p>
                  Os cookies permitem que os websites lembrem as preferências,
                  escolhas e seleções do usuário. A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;também usa o serviço Google Analytics para entender como
                  você navega em nosso site.
                </p>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;não usa cookies para coletar informações pessoais sobre
                  o visitante do seu website.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Seus direitos sob a legislação de proteção de dados
                </h2>
                <p>
                  Você tem o direito de solicitar à&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;a confirmação da existência de tratamento de seus dados
                  pessoais.
                </p>
                <p>
                  Você também tem o direito de receber informações sobre como e
                  porque tratamos seus dados pessoais.
                </p>
                <p>
                  Quando você tiver a opção de determinar como seus dados
                  pessoais serão usados, solicitaremos seu consentimento. Nestes
                  casos, você tem o direito de não fornecer o seu consentimento.
                </p>
                <p>
                  Sempre que você nos fornece o seu consentimento para o
                  tratamento de seus dados pessoais, você recebe o direito de
                  retirar esse consentimento a qualquer momento. Quando a
                  retirada do consentimento tiver um impacto sobre os serviços
                  que podemos oferecer, isso será explicado a você, para que
                  possa determinar se é a decisão certa para você.
                </p>
                <p>
                  Quando você não tiver escolha (por exemplo, quando temos a
                  obrigação legal de processar os dados pessoais), enviaremos um
                  aviso de privacidade. Um aviso de privacidade é uma declaração
                  verbal ou escrita que explica como usamos os dados pessoais.
                </p>
                <p>Você também tem o direito de solicitar:</p>
                <ul className="list-disc pl-6 space-y-2 text-foreground mb-4">
                  <li>
                    o acesso aos dados pessoais controlados pela&nbsp;
                    <strong>
                      RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                    </strong>
                    &nbsp;ou a portabilidade desses dados para outra empresa ou
                    entidade, conforme seja regulamentado pelas autoridades;
                  </li>
                  <li>
                    a correção de dados incompletos, inexatos ou desatualizados;
                  </li>
                  <li>
                    a eliminação de dados desnecessários, excessivos ou
                    coletados indevidamente e a interrupção do tratamento de
                    dados nessas situações;
                  </li>
                  <li>
                    informações sobre as empresas e entidades com as quais
                    compartilhamos seus dados; e
                  </li>
                  <li>
                    a revisão de decisões inteiramente automatizadas que afetem
                    os seus interesses.
                  </li>
                </ul>
                <p>
                  Quando a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;receber uma solicitação de exercício de algum de seus
                  direitos, a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , avaliará a melhor forma de cumpri-la, mas poderá deixar de
                  atender a sua solicitação, total ou parcialmente, se tiver um
                  motivo justo, como, por exemplo, para cumprir uma obrigação
                  legal ou o contrato que mantém com você. Caso você não tenha
                  uma resposta, é possível levar sua solicitação à Autoridade
                  Nacional de Proteção de Dados Pessoais - ANPD.
                </p>
                <p>
                  É importante que a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , mantenha seus dados pessoais precisos e atualizados. Para
                  tanto, mantenha a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , informada se seus dados pessoais mudarem ou estiverem
                  incorretos.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Contato a respeito de seus dados pessoais
                </h2>
                <p>
                  Em conformidade com o art. 41 da Lei nº 13.709/2018 – Lei
                  Geral de Proteção de Dados Pessoais (LGPD) – e com a Resolução
                  CD/ANPD nº 18/2024, a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , pessoa jurídica de direito privado, inscrita no CNPJ sob o
                  nº <strong>04.380.132/0001-47</strong>, com sede na Av.
                  Antônio Diederichsen, nº 400, sala 16, Jardim América,
                  Ribeirão Preto/SP, CEP 14.020-250, informa que contratou como
                  Encarregado pelo Tratamento de Dados Pessoais
                  (&quot;Encarregado&quot;) a empresa:
                </p>
                <p>
                  <strong>MOORE PRISMA CONSULTORES LTDA</strong>, inscrita no
                  CNPJ sob o nº <strong>04.222.143/0001-07.</strong>
                </p>
                <p>
                  A Sra. <strong>Ana Cristina Oliveira Mahle</strong>, atua como
                  representante da Moore nas comunicações com os titulares de
                  dados pessoais e com a Autoridade Nacional de Proteção de
                  Dados (ANPD), conforme previsto na legislação.
                </p>
                <p>
                  Para quaisquer dúvidas acerca deste Aviso de Privacidade,
                  informações sobre os dados que possuímos a seu respeito, ou
                  qualquer outra solicitação ou reclamação relacionada à sua
                  privacidade e ao exercício dos seus direitos previstos na
                  LGPD, entre em contato com nosso Encarregado pelos seguintes
                  canais:
                </p>
                <div className="bg-muted p-6 rounded-lg mb-4">
                  <p className="text-foreground mb-2">
                    <strong>E-mail:</strong>&nbsp;
                    <a
                      href="mailto:dpo@ribercred.com.br"
                      className="hover:underline"
                    >
                      dpo@ribercred.com.br
                    </a>
                  </p>
                  <p className="text-foreground">
                    <strong>Correspondência postal:</strong>
                    <br />
                    A/C Encarregado pelo Tratamento de Dados Pessoais
                    <br />
                    Av. Antônio Diederichsen, nº 400, sala 16, Jardim América
                    <br />
                    Ribeirão Preto/SP – CEP 14.020-250
                  </p>
                </div>
                <p>
                  As solicitações serão tratadas com confidencialidade,
                  transparência e dentro dos prazos legais estabelecidos pela
                  LGPD.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Alterações neste aviso de privacidade
                </h2>
                <p>
                  Este aviso de privacidade visa trazer esclarecimentos e dar
                  transparência acerca das práticas da&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  &nbsp;relativas à privacidade e proteção de dados pessoais de
                  seus fornecedores.
                </p>
                <p>
                  Revisamos regularmente nossas informações de privacidade para
                  garantir que permaneçam precisas e atualizadas. Assim, este
                  aviso pode ser alterado ou substituído a qualquer momento para
                  que a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , possa divulgar novas práticas que venham a ser adotadas.
                </p>
                <p>
                  Revisaremos e atualizaremos essas informações de privacidade
                  sempre que planejarmos usar dados pessoais para qualquer nova
                  finalidade. Quaisquer alterações a essas informações de
                  privacidade serão comunicadas a você.
                </p>
              </section>

              <section className="pt-4">
                <p className="text-sm text-muted-foreground italic">
                  Este aviso de privacidade foi atualizado em&nbsp;
                  <span className="data-atualizacao">12/03/2025.</span>
                </p>
              </section>
            </div>
          </div>
        </PoliticasWrapper>
      </Simple>
    </>
  )
}

export default AvisoPrivacidade
